import { ChevronRight } from '@material-ui/icons';
import { Button, Drawer, Popover, useMediaQuery } from '@material-ui/core';

import { CargoDropDownContent } from './DropdownContent';
import { ReactComponent as RTIcon } from '../../../../assets/images/icons/rappitendero.svg';

import { useCargoLang } from '../../hooks';
import { useHeader } from './hooks/useHeader';
import { useHeaderLang } from './hooks/useHeaderLang';
import { cargoDropdownId } from '../../../../business/cargo';

import useHeaderStyles from './header.styles';

export function CargoHeaderAction({ isEnabled }: Props) {
  const { isDropDownOpen, openDropDown, closeDropDown } = useHeader();
  const { requestRappiTenderoText } = useCargoLang();
  const { dropDownActionsCloseText } = useHeaderLang();
  const isLarge = useMediaQuery((theme: any) => theme.breakpoints.up('md'));
  const styles = useHeaderStyles({ isDropDownOpen, isEnabled });
  const anchorEl = document.getElementById(cargoDropdownId);

  return (
    <>
      <Button
        id={cargoDropdownId}
        onClick={openDropDown}
        startIcon={<RTIcon className={styles.dropDownIcon} />}
        endIcon={isLarge && <ChevronRight />}
        classes={{ root: styles.button, endIcon: styles.buttonEndIcon }}
      >
        {requestRappiTenderoText}
      </Button>

      {isLarge ? (
        <Popover
          open={isDropDownOpen}
          role='tooltip'
          anchorEl={anchorEl}
          onClose={closeDropDown}
          anchorOrigin={{ vertical: -4, horizontal: 'right' }}
          transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          PaperProps={{
            elevation: 0,
            classes: {
              root: styles.popoverPaper,
            },
          }}
        >
          <CargoDropDownContent isEnabled={isEnabled} />
        </Popover>
      ) : (
        <Drawer
          open={isDropDownOpen}
          anchor='bottom'
          onClose={closeDropDown}
          PaperProps={{ classes: { root: styles.drawerPaper } }}
        >
          <CargoDropDownContent isEnabled={isEnabled} />
          <Button
            size='large'
            variant='text'
            onClick={closeDropDown}
            classes={{ root: styles.drawerCloseBtn }}
          >
            {dropDownActionsCloseText}
          </Button>
        </Drawer>
      )}
    </>
  );
}

interface Props {
  isEnabled: boolean;
}
